import React, { useState } from "react";
import "./photo-gallery.scss";
import img1 from "../../assets/election-img/Road.jpeg";
import img2 from "../../assets/election-img/atal-walk-way.jpeg";
import img3 from "../../assets/election-img/farmer.jpeg";
import img4 from "../../assets/election-img/girl-education.jpeg";
import img5 from "../../assets/election-img/home-supply.jpeg";
import img6 from "../../assets/election-img/make-history.jpeg";
import img7 from "../../assets/election-img/people-health.jpeg";
import img8 from "../../assets/election-img/sanjay-gandhi.jpeg";
import img9 from "../../assets/election-img/water-deoni.jpeg";
import img10 from "../../assets/election-img/water-deoni2.jpeg";
import img11 from "../../assets/election-img/water-shirur-anantpal.jpeg";
import img12 from "../../assets/election-img/water-supply.jpeg";
import img13 from "../../assets/election-img/water-mission-nilanga.jpeg";
import { IoClose } from "react-icons/io5";

const PhotoGallery = () => {
  const [visibleImages, setVisibleImages] = useState(4); // Number of images to display initially
  const [selectedImage, setSelectedImage] = useState(null);

  const photos = [
    { id: 1, image: img1 },
    { id: 2, image: img2 },
    { id: 3, image: img3 },
    { id: 4, image: img4 },
    { id: 5, image: img5 },
    { id: 6, image: img6 },
    { id: 7, image: img7 },
    { id: 8, image: img8 },
    { id: 9, image: img9 },
    { id: 10, image: img10 },
    { id: 11, image: img11 },
    { id: 12, image: img12 },
    { id: 13, image: img13 },
  ];

  const handleLoadMore = () => {
    setVisibleImages((prev) => prev + 4); // Show 4 more images
  };

  const handleImageClick = (image) => {
    setSelectedImage(image);
  };

  const closePopup = () => {
    setSelectedImage(null);
  };

  return (
    <div className="photo-parent parent">
      <div className="photo-cont cont">
        <h2>Photo Gallery</h2>
        <div className="main-img-box">
          {photos.slice(0, visibleImages).map((photo) => (
            <div
              className="top-sec bg-img-cover"
              key={photo.id}
              onClick={() => handleImageClick(photo.image)}
            >
              <img src={photo.image} alt={`photo ${photo.id}`} />
            </div>
          ))}
        </div>
        {visibleImages < photos.length && ( // Show "Load More" button only if there are more images to display
          <button className="btn" onClick={handleLoadMore}>
            Load More
          </button>
        )}
        {selectedImage && (
          <div className="popup" onClick={closePopup}>
            <div className="popup-content" onClick={(e) => e.stopPropagation()}>
              <button className="close-btn" onClick={closePopup}>
              <IoClose />
              </button>
              <img src={selectedImage} alt="Selected photo" />
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default PhotoGallery;
